module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ant"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ant",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-3"
  }, [_vm._v("AUTHOR’S NOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("One thing you should know.")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("This world—Paradise—isn’t Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("It wasn’t Earth. It won’t ever be Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("It is no alternate Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("All else is possible.… ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124e41c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 72
// module chunks = 0